export default __webpack_public_path__ + "static/media/outbound.eae41df2.svg";